import loadable from '@loadable/component';
import retryPageImport from './retryPageImport';

function loadablePagePart(importer, options) {
    return loadable(() => retryPageImport(importer), options);
}

export default loadablePagePart;
